import { render } from "./MultiItemGroup.vue?vue&type=template&id=3adc627a&scoped=true"
import script from "./MultiItemGroup.vue?vue&type=script&lang=js"
export * from "./MultiItemGroup.vue?vue&type=script&lang=js"

import "./MultiItemGroup.vue?vue&type=style&index=0&id=3adc627a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adc627a"]])

export default __exports__